/* Copyright (c) 2017 Backpack Health LLC */
import React from 'react';

import AppUtils from '../../utilities/AppUtils';

interface Props {
  scrollPercent: number;
}

class ScrollAwareDropShadow extends React.Component<Props, {}> {
  render() {
    if (AppUtils.isIE11()) return null;

    return (
      <div
        className="cmp-scrollawaredropshadow"
        style={{ opacity: Math.min(this.props.scrollPercent * 1.25, 0.8) }}
      />
    );
  }
}

export default ScrollAwareDropShadow;
